import React from "react";
import "./index.css";
import logo from "../assets/logo.svg";

const SubFooter = () => {
  return (
    <>
      <footer className="footer">
        <div className="container-sm flex flexRow flexWrap space alignCenter">
          <img src={logo} alt="logo" />
          <a
            href="https://mangoycia.com/?utm_source=partners&amp;utm_medium=ssc&amp;utm_campaign=partners"
            target="_blank"
          >
            Mango&amp;Cía - Performance Agency
          </a>
        </div>
      </footer>
    </>
  );
};

export default SubFooter;
